module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/lamp-1-ffaae4391a8eb0af9046629fa01b5c0b.svg";